import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue'

import Brands from './Brands/routes'
import Events from './Events/routes'
import Surveys from './Surveys/routes'
import Servers from './Servers/routes'
import Databases from './Databases/routes'

const SchemaEditor = () => import(/* webpackChunkName: "manage" */ './SelfRegistration/SchemaEditor')

export default [
  {
    path: '/manage',
    name: 'manage-root',

    component: DashboardLayout,
    // redirect: '/manage/self-registration',
    meta: {
      auth: true,
      breadcrumb: {
        label () {
          return this.$gettext('Manage')
        }
      }
    },
    children: [
      {
        path: 'self-registration',
        name: 'admin-self-registration',
        component: SchemaEditor,
        meta: {
          auth: true,
        },
      },
      ...Brands,
      ...Events,
      ...Surveys,
      ...Servers,
      ...Databases,
    ]
  }
]
